"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function standard(v) {
  if (v == null) return null;
  var date;

  if (typeof v === 'number' || typeof v === 'string' || v instanceof Date) {
    date = new Date(v);
  } else {
    date = new Date(+v);
  }

  return date;
}

var _default = standard;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@z-r/calendar/lib/util/standard.js
// module id = 1390
// module chunks = 6 7 17 18